import { UpdateAreaInput } from '@app/models/area.model'
import { LogGaterix, EventResponse, EventStatistics } from '@app/models/event.model'
import { EventLocationResponse } from '@app/models/location.model'

const keys = Object.keys(new EventResponse())

const requestFields = `
${keys.join('\n')}    
status 
predefined_location_id
secured
areas {        
    ${Object.keys(new UpdateAreaInput()).join('\n')}
}
location {        
    ${Object.keys(new EventLocationResponse()).join('\n')}
}
categories {
    name,
    icon,
    id
}
clubs {
    name,
    id
}
entrancesAmount
    event_statistics
    {
            totalTickets
            totalScanned
            maxTickets
            scannedPercent
            wrongEntrance
            wrongEntranceName
            eventMismatch
            blockedFraud
            running
            faulted
            icon
    }

    entrances_statistics
    {
    id
    name
    controller
    default_area_ids
    scan_message_duration
    totalTickets
    totalScanned
    peakPoint
    recentMeanScanRate
    icon
        stations_statistics 
        {
            id
            entrance_id
            ip
            name
            type
            icon
            areas
            keep_open
            totalTickets
            totalScanned
            peakPoint
            recentMeanScanRate
            entranceScanned
            batteryLevel
            version
            extra
        }
}
`

export const RequestPreviewFields = `
    id
    name
    category_icon    
    opening_time
    starting_time
    entrancesAmount
    closing_time    
    keep_open
    status
    category
    description
    location {        
      id
      name
      display_name
    }
    event_statistics{
        ${Object.keys(new EventStatistics()).join('\n')}
    }
`

export const RequestPreviewFieldsEventPage = `
    id
    parent_id
    name
    category_icon    
    opening_time
    starting_time
    entrancesAmount
    closing_time        
    status
    category
    description
    location {        
      id
      name
      display_name
    }
    event_statistics{
            totalTickets
            icon
            totalScanned
    }
`

export const RequestPreviewFieldsCoursesPage = `
    id
    parent_id
    name
    category_icon    
    opening_time
    starting_time
    entrancesAmount
    closing_time        
    status
    category
    description
    location {        
      id
      name
      display_name
    }
`

export const RequestPreviewFieldsSimple = `
    id
    parent_id
    name
    category_icon
    opening_time
    starting_time
    closing_time
    location {        
        name        
    }
    event_statistics{
            scannedPercent
            totalTickets       
            totalScanned        
            maxTickets
            icon
    }
`

export const UPDATE_EVENT = `
    mutation update_event($data: updateEventInput!) {
        update_event(data: $data) {
            success
            errorText
            errorFile
            data {
                ${requestFields}
            }
        }
    }
`

export const RESET_SCANS = `
    mutation resetScans($event_id: Float!, $client_id: Float!) {
        resetScans(
            event_id: $event_id
            client_id: $client_id
        ) {
            success
            errorText
        }
    }
`

export const SEND_MESSAGE = `
    query push_message_event($data: pushMessageEventInput!) {
        push_message_event(data: $data) {
            success
            errorText
            data {
                id
            } 
        }
    }
`

export const DELETE_EVENT = `
    mutation update_event($data: updateEventInput!) {
        update_event(data: $data) {
            success
            errorText
            data {
                active,
                name,
                id
            }
        }
    }
`

export const GET_CATEGORIES = `
query get_event_types($module:ModulesType) { 
    get_event_types (
        module:$module
    ){
        id
        name
        icon
        module
        reports
    }
  }  
`

export const OPEN_DOORS = `
  mutation openDoors($event_id: Float!, $keep_open: Boolean!) {
    openDoors(
        event_id: $event_id
        keep_open: $keep_open
    ) {
        success
        errorText
        data {
            keep_open
            id
        }
    }
  }
`

export const GET_EVENT = `
query get_event($id: Float!, $client_id: Float!) {
    get_event(
        id: $id,
        client_id: $client_id
    ) {
        success
        errorText
        errorFile
        data {
            ${requestFields}
        }
    }
}
`

export const GET_FILTERED_EVENTS = `
query get_filtered_events($data: getFilteredEventsInput!) {
    get_filtered_events(data: $data) {
        success
        errorText
        data {
            ${requestFields}
        }
    }
}
`

export const GET_PREVIEW_FILTERED_EVENTS = `
query get_filtered_events($data: getFilteredEventsInput!) {
    get_filtered_events(data: $data) {
        success
        errorText
        data {
            ${RequestPreviewFields}
        }
    }
}
`

export function GET_FILTERED_EVENTS_WITH(fields: string | null = null) {
  return `
        query get_filtered_events($data: getFilteredEventsInput!,$pageOptions: getPageOptionsInput!) {
            get_filtered_events(data: $data, pageOptions: $pageOptions) {
                success
                errorText
                data {
                    ${fields ? fields : requestFields}
                }
            }
        }
    `
}

export const GET_EVENTS = `
query get_events($client_id: Float!) {
    get_events(
        client_id: $client_id
    ) {
        success
        errorText
        data {
            ${requestFields}
        }
    }
}
`

export const GET_LOGS = `
query get_logs_gaterix($event_id: Float!) {
    get_logs_gaterix(
        event_id: $event_id
    ) {
        success
        errorText
        data {
            ${Object.keys(new LogGaterix())}
        }
    }
}
`

export const SET_EVENT = `
mutation set_event($data: createEventInput!) {
    set_event(data: $data) {
        success
        errorText
        data {
            ${keys.join('\n')}
        }
    }
}
`

export const RequestPreviewFieldsRuleBasedMessagePage = `
    id
    name
    areas{
        id
        name
        event_id
    }
`

export const GET_EVENTS_FOR_SELECTOR = `
query get_filtered_events($data: getFilteredEventsInput!) {
    get_filtered_events(data: $data) {
        success
        errorText
        data {
            id
            name
        }
    }
}
`
